import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Stack } from "@shopify/polaris"
import { useTranslation } from "react-i18next"
import { ExternalLabel } from "components/widgets/CollectPage/forms/fields/CollectFields"
import AiServiceTableLine from "./tables/AiServiceTableLine"
import { useEntity } from "hooks/useAxios"
import AiServicesEntity from "services/entities/AiServicesEntity"
import { useAppContext } from "components/AppContext"

const AiServicesInventory = ({ canAddService }) => {
  const { t } = useTranslation()
  const { reloadEnvCollect } = useAppContext()
  const [aiServices, setAiServices] = useState([])
  const [providersWithModels, setProvidersWithModels] = useState({})

  const aiServicesEntity = useEntity(AiServicesEntity)

  const getAiServices = async () => {
    try {
      const response = await aiServicesEntity.getAiServices()
      setAiServices(response || [])
    } catch (error) {
      console.error("Erreur lors du chargement des services AI:", error)
      setAiServices([])
    }
  }

  const getProvidersWithModels = async () => {
    try {
      const response = await aiServicesEntity.getProvidersWithModels()
      setProvidersWithModels(response || {})
    } catch (error) {
      console.error("Erreur lors du chargement des providers:", error)
    }
  }

  useEffect(() => {
    getAiServices()
    getProvidersWithModels()
  }, [])

  return (
    <div>
      <Stack alignment="center" spacing="tight">
        <ExternalLabel
          pathOverride="13.ai_services"
          translationPathName="table"
        />
      </Stack>

      <AiServiceTableLine
        aiServices={aiServices}
        providersWithModels={providersWithModels}
        refreshData={getAiServices}
        reloadEnvCollect={reloadEnvCollect}
        canAddService={canAddService}
        t={t}
      />
    </div>
  )
}

AiServicesInventory.propTypes = {
  canAddService: PropTypes.bool,
}

export default AiServicesInventory
